module.exports = __webpack_public_path__ + "ebdb28b3f67cad0d6f328b940d0c4c7c.jpg";